export const AUTH_DOMAIN = "auth/";

export const LOG_IN_WITH_PASSWORD = AUTH_DOMAIN + "loginWithPassword";
export const LOG_OUT = AUTH_DOMAIN + "logOut";
export const LOG_IN_SUCCESS = AUTH_DOMAIN + "login";
export const SET_LOGIN_ACCOUNT = AUTH_DOMAIN + "setLoginAccount";